<div class="relative-left bottom-sheet-content full-width x-content-center y-items-center txt-center lato padding-20">
  <div>
    <ng-container *ngIf="sys === 'wt'">
      <h5 class="weight-300">
        {{ 'FAQ.wt.TC.title' | translate }}
        <small class="block margin-top-5 weight-400">
          {{ 'FAQ.wt.TC.paragraph_1' | translate }}
        </small>
      </h5>
      <hr />
      <p class="weight-300 margin-top-10">
        {{ 'FAQ.wt.TC.paragraph_2' | translate }}
      </p>
      <p class="weight-300 margin-top-bottom-5">
        {{ 'FAQ.wt.TC.paragraph_3' | translate }}
      </p>
      <p class="weight-300 margin-top-bottom-5">
        {{ 'FAQ.wt.TC.paragraph_4' | translate }}
      </p>
      <p class="weight-300 margin-top-bottom-5">
        {{ 'FAQ.wt.TC.paragraph_5' | translate }}
      </p>
      <button (click)="closeTerminsAndConditions()" mat-button class="button black md fine margin-top-15" aria-label="Close Dialog">
        {{ 'buttons.accept' | translate }}
      </button>
    </ng-container>
    <ng-container *ngIf="sys === 'ltk'">
      <h5 class="weight-300">
        {{ 'FAQ.ltk.TC.title' | translate }}
        <small class="block margin-top-5 weight-400">
          {{ 'FAQ.ltk.TC.paragraph_1' | translate }}
        </small>
      </h5>
      <hr />
      <p class="weight-300 margin-top-10">
        {{ 'FAQ.ltk.TC.paragraph_2' | translate }}
      </p>
      <p class="weight-300 margin-top-bottom-5">
        {{ 'FAQ.ltk.TC.paragraph_3' | translate }}
      </p>
      <p class="weight-300 margin-top-bottom-5">
        {{ 'FAQ.ltk.TC.paragraph_4' | translate }}
      </p>
      <p class="weight-300 margin-top-bottom-5">
        {{ 'FAQ.ltk.TC.paragraph_5' | translate }}
      </p>
      <button (click)="closeTerminsAndConditions()" mat-button class="button black md fine margin-top-15" aria-label="Close Dialog">
        {{ 'buttons.accept' | translate }}
      </button>
    </ng-container>
  </div>
</div>
